export default __webpack_public_path__ + "static/media/geekbot.94882735.svg";